import React from 'react';
import type { AstroCommandServices } from '@wix/cli-command-contract';
import { NO_TTY_JSON_OUTPUT_OPTION } from '@wix/cli-command-contract';
import { createCommand, Option } from '@commander-js/extra-typings';
import { validateBase, validateLabel } from './validations.js';

export const previewCommand = (
  services: AstroCommandServices,
  cliVersion: string
) => {
  return createCommand('preview')
    .description('Create a preview version of your application')
    .addOption(
      new Option(
        '--base-url <url>',
        'The base url for when static files have been uploaded to an external cdn'
      )
        .argParser(validateBase)
        .hideHelp()
    )
    .addOption(
      new Option('-l, --label <label>', 'A custom label for this preview')
        .argParser(validateLabel)
        .hideHelp()
    )
    .addOption(
      new Option(
        '--preview-id <preview-id>',
        'An existing preview override id to update'
      ).hideHelp()
    )
    .addOption(new Option('--site <site>', '(deprecated)').hideHelp())
    .addOption(
      new Option(NO_TTY_JSON_OUTPUT_OPTION, 'Output in JSON format').hideHelp()
    )
    .action(async (options, command) => {
      const { baseUrl, json, label, previewId } = options;

      const { renderCommand, runCommand } = await import('./render-command.js');

      if (json) {
        return runCommand(command, services, cliVersion, async (model) => {
          const { nonInteractivePreview } = await import(
            '../non-interactive/preview.js'
          );
          return nonInteractivePreview(services, model, {
            baseUrl,
            label,
            previewId,
          });
        });
      }

      const { PreviewCommand } = await import(
        '../components/PreviewCommand/index.js'
      );

      await renderCommand(
        command,
        services,
        cliVersion,
        <PreviewCommand
          baseUrl={baseUrl}
          label={label}
          previewId={previewId}
          environment="preview"
        />
      );
    });
};
